export const getNodes = data => data.edges.map(d => d.node);
export const isEmpty = thing => !thing || thing === '';
export const defaultColor = color => (isEmpty(color) ? '#fff' : color);
